import { Button } from 'src/components';
import styled, { css } from 'styled-components';

export const SimpleChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 16px 8px 16px;
  gap: 8px;
`;

export const Title = styled.h4`
  overflow: hidden;
  color: ${(props) => props.theme.colors.constrat};
  text-overflow: ellipsis;
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-bottom: 2px;
`;

export const Text = styled(Title)`
  padding-bottom: 0;
`;

export const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RadiosWrapper = styled.div`
  max-height: ${(props) => props.isSmall ? '14px' : '16px'};
  display: flex;
  gap: ${(props) => props.isSmall ? '4px' : '8px'};
  align-items: center;
  flex-direction: row;
`;

export const RadiusButton = styled(Button)`
  cursor: pointer;

  ${({ disabled }) => disabled ? css`
    pointer-events: none;
  ` : ''}

  padding: 0px;
  height: 20px;
  width: 20px;
  margin-right: 2px;
  background-color: transparent;

  &:hover {
    background-color: transparent;
    color: transparent;
  }
`;

export const OrderOptions = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-left: 38px;
  margin-top: 8px;
  gap: 16px;
`;

export const Circle = styled.span`
  width: ${(props) => props.isSmall ? '12px' : '16px'};
  height: ${(props) => props.isSmall ? '12px' : '16px'};
  border-radius: 50%;
  border: 1px solid
    ${(props) =>
    props.isChecked
      ? props.theme.colors.secondary
      : props.theme.colors.text.default};
  display: inline-block;
  background: none;
  box-sizing: border-box;
  padding: 1px;
  position: relative;

  :after {
    content: "";
    display: block;
    border-radius: 50%;
    width: 6px;
    height: 6px;
    position: absolute;
    left: calc(50% - 3px);
    top: calc(50% - 3px);
    background: ${(props) =>
    props.isChecked ? props.theme.colors.secondary : "transparent"};
  }
`;